import React, { Component } from "react";
import { Table, Container } from "semantic-ui-react";

import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

export const getDefaultFiber = () => ({
  FB1: {
    channel2: 0,
    channel3: 0,
    signal: false,
    statusChannel2: "",
    statusChannel3: ""
  }
});

export const getDefaultFiberChannelActive = () => ({
  FB1: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false
  }
});

export const normalizeFiber = (fiber) => ({
  FB1: {
    ...getDefaultFiber().FB1,
    ...(fiber && typeof fiber.FB1 === "object" ? fiber.FB1 : {})
  }
});

export const normalizeFiberChannelActive = (fiberChannelActive) => ({
  FB1: {
    ...getDefaultFiberChannelActive().FB1,
    ...(fiberChannelActive && typeof fiberChannelActive.FB1 === "object" ? fiberChannelActive.FB1 : {})
  }
});

export class OpticFiber extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      channel2: 0,
      channel3: 0,
      signal: false,
      channel2Active: false,
      channel3Active: false,
      signalActive: false,
      statusChannel2: "",
      statusChannel3: "",
      fiberIntervalID: -1
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "fiber", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiber)
        .catch((error) => {
          console.log(error);
          return getDefaultFiber();
        })
    );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "fiber/fiberChannelActive", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiberChannelActive)
        .catch((error) => {
          console.log(error);
          return getDefaultFiberChannelActive();
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      channel2: resolvedPromisses[0].FB1.channel2,
      channel3: resolvedPromisses[0].FB1.channel3,
      signal: resolvedPromisses[0].FB1.signal,
      statusChannel2: resolvedPromisses[0].FB1.statusChannel2,
      statusChannel3: resolvedPromisses[0].FB1.statusChannel3,
      signalActive: resolvedPromisses[1].FB1.signalActive,
      channel2Active: resolvedPromisses[1].FB1.channel2Active,
      channel3Active: resolvedPromisses[1].FB1.channel3Active,
    });

  };

  getVoltageValue = (value) => {
    const voltage = value !== null ? value.toFixed(2).replace(".", ",") : "";
    return voltage.concat(Strings.VOLTAGE);
  }

  getSignalTable = () => {
    if (this.state.signal && this.state.signalActive) {
      return (
        <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell verticalAlign="middle" style={okCellStyle}>
                {Strings.OK}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    else if ((!this.state.signal && this.state.signalActive)) {
      return (
        <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell verticalAlign="middle" style={badCellStyle}>
                {Strings.FAULT}
              </Table.Cell>
            </Table.Row >
          </Table.Body>
        </Table>
      );
    }
  }

  getChannelTableRow = (channel, isChannelActive) => {
    if (isChannelActive && channel === 2) {
      return (
        <Table.Row>
          <Table.Cell verticalAlign="middle">{Strings.CHANNEL_2}</Table.Cell>
          <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel2)}</Table.Cell>
          {this.createStatusCell(this.state.statusChannel2)}
        </Table.Row>
      );
    }
    else if (isChannelActive && channel === 3) {
      return (
        <Table.Row>
          <Table.Cell verticalAlign="middle">{Strings.CHANNEL_3}</Table.Cell>
          <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel3)}</Table.Cell>
          {this.createStatusCell(this.state.statusChannel3)}
        </Table.Row>
      );
    }
  }

  createStatusCell = (StatusChannel) => {
    if (StatusChannel === Constants.GOOD) {
      return (
        <Table.Cell
          style={okCellStyle}>
          {Strings.GOOD_STRING}
        </Table.Cell>
      );
    }
    else if (StatusChannel === Constants.ATTENTION) {
      return (
        <Table.Cell
          style={attentionCellStyle}>
          {Strings.ATTENTION_STRING}
        </Table.Cell>
      );
    }
    else if (StatusChannel === Constants.BAD) {
      return (
        <Table.Cell
          style={badCellStyle}>
          {Strings.BAD_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          style={unknownCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }
  
  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ fiberIntervalID: setInterval(() => { this.retrieveData(); }, 1000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.fiberIntervalID);
  }

  render() {
    return (
      <Container>
        <Table striped celled fixed singleLine textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell disabled>{Strings.CHANNEL}</Table.HeaderCell>
              <Table.HeaderCell disabled>{Strings.SIGNAL_QUALITY}</Table.HeaderCell>
              <Table.HeaderCell disabled>{Strings.STATUS}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.getChannelTableRow(2, this.state.channel2Active)}
            {this.getChannelTableRow(3, this.state.channel3Active)}
          </Table.Body>
        </Table>
        {this.getSignalTable()}
      </Container>
    );
  }
}

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle"
};

const signalTableStyle = {
  marginTop: "50px",     // espaço entre uma tabela e outra
  width: "34%",          // diminui a largura da tabela
  marginLeft: "auto",
  marginRight: "auto"
};

export default OpticFiber;